/* eslint-disable no-unused-vars */
import React, { Component, PropTypes } from 'react';

// utilities
import _, { get } from 'lodash';
import { connect } from 'react-redux';

import prettyDate from '../../../../../lib/prettyDate';

// components
import TextField from '../../../../../common/components/c_TextField';
import TextArea from '../../../../../common/components/c_TextArea';
import DropDownMenu from '../../../../../common/components/c_DropDownMenu';
import DateInput from '../../../../../common/components/DateInput';
import { ListItem } from 'material-ui';

const dropDownCustomization = {
  labelStyle: {
    padding: 0,
    margin: 0,
    maxWidth: '90%'
  },
  underlineStyle: {
    marginLeft: 0
  },
  containerStyle: {
    width: 'calc(50% - 35px)',
    margin: '30px 0 10px 45px'
  },
  floatingLabelStyle: {
    left: 0,
    top: '-10px'
  }
};

const secondDropDown = _.merge({}, dropDownCustomization, {
  containerStyle: {
    margin: '30px 0 10px 10px'
  }
});
const noMargin = {
  containerStyle: {
    margin: '30px 0 10px 0px'
  }
};

const textFieldStyle = {
  margin: '-8px 0 2px',
  width: '100%',
  minHeight: '100px',
  lineHeight: '1.63',
};

const secondTextField = {
  width: 'calc(50% - 35px)',
  margin: '-8px 0 8.5px',
  display: 'inline-block',
  verticalAlign: 'text-bottom'
};
const questionSection = [
  {
    type: 'DropDown',
    text: 'Hourly rate range acceptable',
    options: [
      {value: 'true', primaryText: 'Yes'},
      {value: 'false', primaryText: 'No'}
    ],
    propertyName: 'hourlyRateAcceptable'
  },
  {
    type: 'TextField',
    text: 'What would be your minimum desired hourly pay rate?',
    propertyName: 'desiredHourlyRate'
  },
  {
    type: 'TextArea',
    text: 'Tell me about your work at you most recent/current job.',
    propertyName: 'mostRecentWork'
  },
  {
    type: 'TextArea',
    text: 'Briefly describe for me the firm/company you are/were working for, for example, the size of the company, # of employees, # of offices, your department, the culture, etc.',
    propertyName: 'mostRecentWorkFirmType'
  },
  {
    type: 'TextArea',
    text: 'How long have you been doing this type of work?',
    propertyName: 'mostRecentWorkDuration'
  },
  {
    type: 'TextArea',
    text: "Okay, that's great. What type of work did you do before that?",
    propertyName: 'previousTypeOfWork'
  },
  {
    type: 'DropDown',
    text: 'Have you ever had the opportunity to work remotely?',
    options: [
      {value: true, primaryText: 'Yes'},
      {value: false, primaryText: 'No'}
    ],
    propertyName: 'hasWorkedRemotely'
  },
  {
    type: 'TextArea',
    text: 'Please tell me about it.',
    text1: 'How do you feel about working from home?',
    propertyName: 'hasWorkedRemotelyComment'
  }
];

function genFakeDropdown(str) {
  return {
    value: str,
    menuItems: [str],
    disabled: true
  };
}

@connect(store => {
  return {
    labels: get(store, 'labels.PreliminaryProfile', {})
  };
})
export default class PreliminaryProfile extends Component {

  static propTypes = {
    staticData: PropTypes.object,
    applicant: PropTypes.object,
    script: PropTypes.bool,
    tempState: PropTypes.object,
    model: PropTypes.string.isRequired,
    updateTempState: PropTypes.func,
    labels: PropTypes.object
  };

  render() {

    const currentWorkFromHomeReason = this.props.tempState.workFromHomeReason || this.props.applicant.profile.workFromHomeReason;
    const otherId = this.props.staticData.applicantWorkFromHomeReasonsList[this.props.staticData.applicantWorkFromHomeReasonsList.length - 1].id;
    const showOther = currentWorkFromHomeReason && currentWorkFromHomeReason === otherId;

    // booleans
    const script = this.props.script;
    const isEmployed = this.props.applicant.profile.employmentStatus.name === 'Phasing into Retirement' || this.props.applicant.profile.employmentStatus.name === 'Employed';
    const isFullTime = (_.get(this.props.tempState, 'profile.currentWorkStatus.id') || this.props.applicant.profile.currentWorkStatus) === 1;

    // handles tempState updates
    function onChange(property, event, value, name) {

      value = !_.isBoolean(value) && !_.isNumber(value) && _.isEmpty(value) ? ' ' : value;

      if(showOther && property === 'workFromHomeReason' && value !== otherId) {
        this.props.updateTempState(this.props.model, 'workFromHomeReasonOther', event, ' ');
      }

      // handle dropdown
      if(name) {
        value = {
          id: value,
          name
        };
      }

      if(this.props.applicant.profile[property] !== value) { // add to tempstate
        this.props.updateTempState(this.props.model, property, event, value);
      } else if(_(this.props.tempState).omit(property).size()) { // remove from tempState if there remains properties on tempState without it
        this.props.updateTempState(this.props.model, property, event, value);
      } else { // wipe tempstate if this was only property
        this.props.updateTempState(null, null, null, null);
      }

    }


    return (
      <div className='expanded-accordion-content prelim-interview'
        key={`prelim-profile ${this.props.applicant.profile.id}`}>
        {
          script
        &&
        <div>
          <div className='speaking-callout'>
          {this.props.labels.speakingCallout}
          </div>
        </div>
        }
          <DropDownMenu floatingLabelText='Employment status'
          className='employment-status-dropdown'
          value={this.props.applicant.profile.employmentStatus.id}
          menuItems={this.props.staticData.employmentStatusList}
          onChange={onChange.bind(this, 'employmentStatus')}
          {...dropDownCustomization}/>
          {
            isEmployed
            &&
            <DropDownMenu floatingLabelText='Are you working full-time or part time now?'
            className='work-status-dropdown'
            value={this.props.applicant.profile.currentWorkStatus}
            menuItems={this.props.staticData.currentEmploymentStatusList}
            onChange={onChange.bind(this, 'currentWorkStatus')}
            {...secondDropDown}/>
          }
          {
            isFullTime && script
            &&
            <div className='speaking-callout'>
          If working full-time, explain: All our jobs require that you are available during regular working hours for at least part of the time. You cannot work full-time and also work for WAHVE.
                                                                                                                                                                                            </div>
            }
            <DateInput data-id='date available to begin'
                      className='availability-date dropdown-wrapper'
                      floatingLabelText='Date available to start work'
                      container={'block'}
                      minDate={new Date()}
                      autoOk
                      defaultValue={_.get(this.props.tempState, 'profile.availabilityDate', null) ? this.props.tempState.profile.availabilityDate : this.props.applicant.profile.availabilityDate}
                      value={_.get(this.props.tempState, 'profile.availabilityDate', null) ? this.props.tempState.profile.availabilityDate : this.props.applicant.profile.availabilityDate}
                      onChange={onChange.bind(this, 'availabilityDate')}
                        />
          <DropDownMenu floatingLabelText={this.props.labels.totalYearsExperience}
            className='total-years-dropdown'
            {...genFakeDropdown(this.props.applicant.profile.totalYearsExperienceNumeric || this.props.applicant.profile.totalYearsExperience)}
            {...dropDownCustomization}/>
          <DropDownMenu floatingLabelText={this.props.labels.industryYearsExperience}
            className='total-years-insurance-dropdown'
            {...genFakeDropdown(this.props.applicant.profile.industryYearsExperienceNumeric || this.props.applicant.profile.industryYearsExperience)}
            {...secondDropDown}/>
          <DropDownMenu floatingLabelText={this.props.labels.workedLastInIndustryYesNo}
            className='last-in-insurance-dropdown'
            {...genFakeDropdown(this.props.applicant.profile.workedLastInIndustry === 'More than 5 years ago' ? 'No' : 'Yes')}
            {...dropDownCustomization}/>
          <DropDownMenu floatingLabelText={this.props.labels.foundUsVia}
            canAutoPosition='true'
            className='found-us-via admin'
            value={this.props.applicant.profile.foundUsVia.id}
            menuItems={this.props.staticData.foundUsViaList}
            onChange={onChange.bind(this, 'foundUsVia')}
            {...secondDropDown}>
            {{
                Other: <TextField floatingLabelText='Please Specify'
                          defaultValue={typeof this.props.tempState.foundUsOther === 'string' ? this.props.tempState.foundUsOther : this.props.applicant.profile.foundUsOther}
                          onBlur={onChange.bind(this, 'foundUsOther')}
                          style={secondTextField}/>
            }}
          </DropDownMenu>
            {/* // NEED INDUSTRY TYPES, NOT GETTING FROM APPLICANT*/}
          <div data-id='Instructions 2'
            className='callout'>
            <TextField value={this.props.applicant.profile.industries.map(obj => obj.name).join(', ')}
              disabled
              multiLine
              floatingLabelText={this.props.labels.industries}
              style={textFieldStyle}/>
          </div>
          <div className='expanded-accordion-content explanation-of-wahve review-explanations'>
            {
            <ul className='instructions-list' style={{paddingBottom: !this.props.script ? '15px' : null}}>
            {
              questionSection.map((listItem, questionKey) =>
              <li
                className='instructions-list-item'
                key={questionKey}
                >
                <div className='instructions-list-text'>
                  { /* should refactor this to remove the hard-coding aspect and choose listItem.text or listItem.text1 based on a property in the questionSection[] */
                    (listItem.propertyName === 'hasWorkedRemotelyComment'
                    && !((this.props.tempState.profile||{}).hasOwnProperty('hasWorkedRemotely') ? this.props.tempState.profile.hasWorkedRemotely.id : this.props.applicant.profile.hasWorkedRemotely))
                    ?
                    listItem.text1
                    :
                    listItem.text
                  }
                </div>
                {
                listItem.type === 'TextField'
                &&
                <TextField
                  data-id={listItem.propertyName}
                  className='instructions-text-field'
                  style={secondTextField}
                  defaultValue={this.props.applicant.profile[listItem.propertyName]}
                  onBlur={onChange.bind(this, listItem.propertyName)}
                />
                ||
                (listItem.type === 'TextArea')
                &&
                <TextArea data-id={listItem.propertyName}
                  className='instructions-text-field'
                  style={textFieldStyle}
                  defaultValue={this.props.applicant.profile[listItem.propertyName] || ''}
                  onBlur={onChange.bind(this, listItem.propertyName)}
                />
                ||
                listItem.type === 'DropDown'
                &&
                <DropDownMenu data-id={listItem.propertyName}
                  className='instructions-dropdown'
                  value={this.props.applicant.hasOwnProperty(listItem.propertyName) ? this.props.applicant.profile[listItem.propertyName].id : // #theWorst
                    this.props.applicant.profile.hasOwnProperty(listItem.propertyName) && this.props.applicant.profile[listItem.propertyName] && this.props.applicant.profile[listItem.propertyName].hasOwnProperty('id') ?
                      this.props.applicant.profile[listItem.propertyName].id :
                      this.props.applicant.profile.hasOwnProperty(listItem.propertyName)? this.props.applicant.profile[listItem.propertyName] : null}
                  onChange={onChange.bind(this, listItem.propertyName)}
                  menuItems={listItem.options}
                  {...secondDropDown}/>
                }
            </li>
            )
            }
            </ul>
            }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Review/f_PreliminaryProfile/index.js